<template>
	<div class="corporate-client-page">
		<header-component
			:is-soon="false"
			img-left="/trocachip/img/setinha-left-preto.svg"
			img-right="/trocachip/img/access.png"
			class="header-component"
		/>

		<div class="corporate-client-page-content">
			<img src="../assets/images/ic_error.svg" alt="error" title="error" />
			<strong v-html="title"></strong>

			<span v-html="subtitle"></span>
			<a
				:href="link"
				target="_blank"
				rel="noopener noreferrer"
				v-html="link"
				v-on:click="eventTracking"
			></a>
		</div>
	</div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent';
import { mapState } from 'vuex';
import trackEvent from '../services/trackEvent';

export default {
	name: 'CorporateClientBlock',
	components: {
		HeaderComponent,
	},
	data() {
		return {
			title: '',
			subtitle: '',
			link: '',
		};
	},
	computed: {
		...mapState({
			config: (state) => state.config,
			customer: (state) => state.customer,
			protocol: (state) => state.protocol
		}),
	},
	created() {
		const config = this.config.corporate_client_block_page;
		if (this.isExOi()) {
			this.title = config.clientExOi.title;
			this.subtitle = config.clientExOi.subtitle;
			this.link = config.clientExOi.link;
		} else {
			this.title = config.default.title;
			this.subtitle = config.default.subtitle;
			this.link = config.default.link;
		}
		return;
	},
	methods: {
		eventTracking() {
			trackEvent.track({
				user: {
					login: this.customer.login,
					loginType: this.customer.loginType,
					lineType: this.customer.lineType,
					segment: this.customer.segment,
					subSegment: this.customer.subSegment,
					planCode: this.customer.planCode,
					planName: this.customer.planName,
				},
				channel: trackEvent.getChannel(),
				'event-category': 6,
				'event-label': this.isExOi() ? 
					'Troca de Chip Cliente Oi Corporativo' : 
					'Troca de Chip Cliente Corporativo',
				'event-value': null,
				'event-status': 'Sucesso',
				'event-interactionNumber': this.protocol,
			});
		},
		isExOi() {
			return this.customer.isExOiCustomer;
		},
	},
};
</script>

<style lang="scss" scoped>
.corporate-client-page {
	width: 100vw;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
}

.corporate-client-page-content {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	font-family: 'timsans_regular';
	text-align: center;
}

.corporate-client-page-content strong {
	font-size: 32px;
	font-weight: 300;
	margin-top: 37px;
}

.corporate-client-page-content span {
	margin-top: 27px;
}

.corporate-client-page-content span,
a {
	opacity: 0.6;
	font-size: 16px;
	color: #000000 !important;
}
</style>
